/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import styles from "./LandingHeader.module.scss";
import hamMenu from "../../../assets/images/hamMenu.svg";
import crossMenu from "../../../assets/images/crossMenu.svg";
import logoutBlue from "../../../assets/images/logout_blue.svg";
import { getCookie, deleteCookie } from "../../../utils/utils";
import { useHistory } from "react-router-dom";
import { StoreContext } from "../../ContextStore/StoreContextProvider";
import Indonesia from "../../../assets/images/Indonesia.svg";
import Vietnam from "../../../assets/images/vietnam.svg";
import Thailand from "../../../assets/images/Thailand.svg";
import Cambodia from "../../../assets/images/Cambodia.svg";
import Laos from "../../../assets/images/Laos.svg";
import Philippines from "../../../assets/images/Phillipines.svg";
import Pakistan from "../../../assets/images/Pakistan.svg";
import Bangladesh from "../../../assets/images/Bangladesh.svg";
import { isMobile } from "react-device-detect";
import ProfileIcon from "../../../assets/images/profileIcon.svg";
import { Tooltip } from "react-tooltip";
import { doSSOLogout } from "../../../firebase/ssoAuthenticate";
import Select from "react-select";
import configData from "../../../common/configData.json";
import GaEventHelper from '../../../helper/ga-event-helper';
import { GA_EVENTS } from '../../../common/gaEventConstants';
import { getCountry, getCountryName } from "./LandingHelper";
import { logoutService } from "../../../services/SessionService";
import { shouldRenderOfflineApp } from "../../../helper/FileHelper";
import newHeaderLogo from "../../../assets/images/headerLogo.svg";
import logoutProfileIcon from "../../../assets/images/logoutProfileIcon.svg";
import LandingTabs from "../../LandingTabs/LandingTabs";


const LandingHeader = () => {
  const { userDetails, selectedCountryCode, updateCountryCode, selectedBsa } =
    useContext(StoreContext);
  const [menu, setMenu] = useState(false);
  const history = useHistory();
  const filteredCountries = [];
  const [isHamburgerView, setIsHamburgerView] = useState(
    window.innerWidth <= 848
  );
  const [isProfileTooltipOpen, setIsProfileTooltipOpen] = useState(false);

  const handleMenu = () => {
    setMenu(!menu);
  };
  /* Navigate to landing screen on logo click */
  const handleHeaderLogoNavigation = () => {
    history.push("/landingscreen");
  };
  const profileTriggerRef = useRef(null);
  const profileTooltipRef = useRef(null);

  const isIndonesia = localStorage.getItem("isIndonesia");
  const isVietnam = localStorage.getItem("isVietnam");
  const isPhilipines = localStorage.getItem("isPhilipines");
  const isThailand = localStorage.getItem("isThailand");
  const isPakistan = localStorage.getItem("isPakistan");
  const isBangladesh = localStorage.getItem("isBangladesh");
  const isCambodia = localStorage.getItem("isCambodia");
  const isLaos = localStorage.getItem("isLaos");
  const isIndonesiaIc = localStorage.getItem("isIndonesiaIc");
  const isHPC = configData?.common?.id?.isHPC;
  const srcValue = getCountry(selectedCountryCode)
  const countryName = getCountryName(selectedCountryCode, isHPC)
  const profileRole = userDetails?.magnifyAccessLevel;
  const magnifAiAccess = userDetails?.accessToMagnifAi?.toLowerCase();
  const magnifyAccessLevel = userDetails?.magnifyAccessLevel?.toLowerCase();
  const canViewUserAccessManagement = magnifyAccessLevel === "super user";
  const canViewManageCohorts = magnifyAccessLevel !== "view only";
  const offlineAppCond = userDetails?.email?.endsWith("@unilever.com");
  const tabPathToIdMap = {
    "/managecohorts": "manageCohorts",
    "/promoutilisationtracking": "promoUtilisationTracking",
    "/impactonbusiness": "impactOnBusiness",
    "/leadershipview": "leadershipView",
    "/useraccessmanagement": "userAccessManagement",
  };
  const activeTabId = tabPathToIdMap[history?.location?.pathname] || "manageCohorts";
  const isLandingScreenRoute = ["/landingscreen", "/"].includes(history?.location?.pathname);
  const isCohortWizardRoute = ["/createcohort", "/previewcohort", "/setupcohortparameter"].includes(history?.location?.pathname);
  const tabItems = [
    {
      id: "manageCohorts",
      label: "Manage Cohorts",
      visible: canViewManageCohorts,
      onClick: () => {
        history.push("/managecohorts");
      },
    },
    {
      id: "promoUtilisationTracking",
      label: "Promo Utilisation Tracking",
      onClick: () => {
        history.push("/promoutilisationtracking");
      },
    },
    {
      id: "impactOnBusiness",
      label: "Impact on Business",
      onClick: () => {
        history.push("/impactonbusiness");
      },
    },
    {
      id: "leadershipView",
      label: "Leadership view",
      onClick: () => {
        history.push("/leadershipview");
      },
    },
    {
      id: "userAccessManagement",
      label: "User Access Management",
      visible: canViewUserAccessManagement,
      onClick: () => {
        history.push("/useraccessmanagement");
      },
    },
  ];

  const countries = [
    {
      label: (
        <div className={styles.countryName}>
          <img src={Indonesia} className={styles.countryLogo} alt="" />
          {isHPC ? <p className={styles.nameOption}>{"Indonesia HPC"}</p> : <p className={styles.nameOption}>{"Indonesia"}</p>}
        </div>
      ),
      value: "id",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Indonesia} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Indonesia IC"}</p>
        </div>
      ),
      value: "idic",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Vietnam} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Vietnam"}</p>
        </div>
      ),
      value: "vn",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Philippines} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Philippines"}</p>
        </div>
      ),
      value: "ph",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Thailand} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Thailand"}</p>
        </div>
      ),
      value: "th",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Pakistan} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Pakistan"}</p>
        </div>
      ),
      value: "pk",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Bangladesh} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Bangladesh"}</p>
        </div>
      ),
      value: "bd",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Cambodia} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Cambodia"}</p>
        </div>
      ),
      value: "kh",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Pakistan} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Indonesia IC"}</p>
        </div>
      ),
      value: "idic",
    },
    {
      label: (
        <div className={styles.countryName}>
          <img src={Laos} className={styles.countryLogo} alt="" />
          <p className={styles.nameOption}>{"Laos"}</p>
        </div>
      ),
      value: "la",
    },
  ];

  if (isIndonesia) {
    filteredCountries.push(countries.find((country) => country.value === "id"));
  }

  if (isIndonesiaIc) {
    filteredCountries.push(countries.find((country) => country.value === "idic"));
  }

  if (isVietnam) {
    filteredCountries.push(countries.find((country) => country.value === "vn"));
  }

  if (isPhilipines) {
    filteredCountries.push(countries.find((country) => country.value === "ph"));
  }

  if (isThailand) {
    filteredCountries.push(countries.find((country) => country.value === "th"));
  }

  if (isPakistan) {
    filteredCountries.push(countries.find((country) => country.value === "pk"));
  }

  if (isBangladesh) {
    filteredCountries.push(countries.find((country) => country.value === "bd"));
  }

  if (isCambodia) {
    filteredCountries.push(countries.find((country) => country.value === "kh"));
  }

  if (isLaos) {
    filteredCountries.push(countries.find((country) => country.value === "la"));
  }

  const shouldShowCountryDropdown =
     (magnifyAccessLevel === "super user" ||
      magnifyAccessLevel === "view only" || 
      magnifyAccessLevel === "creator") &&
      filteredCountries.filter(Boolean).length >= 1;

  useEffect(() => {
    localStorage.setItem("smTarget", 'N')
  }, [selectedCountryCode])

  // Keep header behavior aligned with the responsive hamburger breakpoint.
  useEffect(() => {
    const onResize = () => {
      setIsHamburgerView(window.innerWidth <= 848);
    };

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);


  const logoutHandler = async () => {
    GaEventHelper.gaCommonEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: GA_EVENTS.logout })
    logoutService(selectedCountryCode);

    const clearSessionAndRedirect = () => {
      getCookie("idToken") && deleteCookie("idToken");
      getCookie("refreshToken") && deleteCookie("refreshToken");
      getCookie("isSSOLogin") && deleteCookie("isSSOLogin");
      getCookie("isMFALogin") && deleteCookie("isMFALogin");
      getCookie("countryCode") && deleteCookie("countryCode");
      localStorage.removeItem("countryCode");
      localStorage.removeItem("isIndonesia");
      localStorage.removeItem("isIndonesiaIc");
      localStorage.removeItem("isVietnam");
      localStorage.removeItem("isPhilipines");
      localStorage.removeItem("isThailand");
      localStorage.removeItem("isPakistan");
      localStorage.removeItem("isBangladesh");
      localStorage.removeItem("isCambodia");
      localStorage.removeItem("isLaos");
      localStorage.removeItem("adminAccess");
      localStorage.removeItem("selectedDropdownLabel");
      localStorage.removeItem("email");
      localStorage.removeItem("loginType");
      localStorage.removeItem("isSSOLogin");
      localStorage.removeItem("UUID");
      localStorage.removeItem("localId");
      history.push("/login");
    };

    if (getCookie("isSSOLogin") || getCookie("isMFALogin")) {
      await doSSOLogout();
      clearSessionAndRedirect();
      return;
    }

    clearSessionAndRedirect();
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      profileTriggerRef.current &&
      !profileTriggerRef.current.contains(event.target) &&
      profileTooltipRef.current &&
      !profileTooltipRef.current.contains(event.target)
    ) {
      setIsProfileTooltipOpen(false);
    }
  };

  const changeCountryCodeHandler = (event) => {
    GaEventHelper.gaCommonEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: GA_EVENTS.Select_country });
    updateCountryCode(event.value);
    localStorage.setItem("countryCode", event.value);
  };

  const handleUserAccessManagementNavigation = () => {
    setIsProfileTooltipOpen(false);
    setMenu(false);
    history.push("/useraccessmanagement");
  };
  
  return (
    <>
      <div className={styles.mainHeader}>
        <div className={styles.header}>
          <div className={styles.headertop}>
            <button
              type="button"
              className={styles.dttReports}
              onClick={handleHeaderLogoNavigation}
              aria-label="Go to landing screen"
            >
              <img src={newHeaderLogo} className={styles.logoText} alt="Cohorting Portal" />
            </button>
            {/* Toggle the compact navigation drawer on smaller screens. */}
            <button
              className={styles.hamburgerBtn}
              onClick={handleMenu}
              aria-label={menu ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={menu}
            >
              <img
                src={menu ? crossMenu : hamMenu}
                alt={menu ? "Close menu" : "Open menu"}
              />
            </button>
            <div className={menu ? styles.menuSide : styles.navlinks}>
              {!menu && (
                <>
                  {isMobile && (
                    <button
                      type="button"
                      className={styles.SMOMobileView}
                      onClick={logoutHandler}
                      aria-label="Logout"
                    >
                      <img
                        src={logoutBlue}
                        className={styles.menuIcons}
                        alt="Logout"
                      />
                      <p>Logout</p>
                    </button>
                  )}
                </>
              )}
              {(!isMobile || menu) &&
                (!shouldShowCountryDropdown) && (
                  <div className={styles.countryName}>
                    <img
                      src={srcValue}
                      className={styles.countryLogo}
                      alt=""
                    />
                    <p className={styles.name}>
                      {countryName}
                    </p>
                  </div>
                )}
              {(!isMobile || menu) &&
                shouldShowCountryDropdown && (
                  <Select
                    inputId="country-selector"
                    aria-label="Select country"
                    tabIndex={0}
                    tabSelectsValue
                    options={filteredCountries.filter(Boolean)}
                    onChange={changeCountryCodeHandler}
                    isSearchable={false}
                    isDisabled={!isLandingScreenRoute}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        border: 'none',
                        boxShadow: 'none',
                        outline: state.isFocused && !state.menuIsOpen ? '2px solid #0066CC' : 'none',
                        outlineOffset: '2px',
                        '&:hover': { border: 'none', boxShadow: 'none' },
                      }),
                    }}
                    classNames={{
                      container: () => styles.dropdownCountry,
                      control: () => styles.dropdownControl,
                      valueContainer: () => styles.dropdownControl,
                      indicatorsContainer: () => (isLandingScreenRoute ? styles.dropdownArrow : styles.dropdownArrowHidden),
                      singleValue: () => styles.dropdownText,
                      placeholder: () => styles.dropdownText,
                      indicatorSeparator: () => styles.seperator,
                      option: () => styles.menuOption,
                      menu: () => styles.menu,
                      menuList: () => styles.menuList,
                    }}
                    defaultValue={{
                      label: (
                        <div className={styles.countryName}>
                          <img
                            src={srcValue}
                            className={styles.countryLogo}
                            alt=""
                          />
                          <p className={styles.name}>
                            {countryName}
                          </p>
                        </div>
                      ),
                      value: selectedCountryCode,
                    }}
                    value={{
                      label: (
                        <div className={styles.countryName}>
                          <img
                            src={srcValue}
                            className={styles.countryLogo}
                            alt=""
                          />
                          <p className={styles.name}>
                            {countryName}
                          </p>
                        </div>
                      ),
                      value: selectedCountryCode,
                    }}
                  />
                )}
              {(!menu || !isHamburgerView) && (
                <>
                  <span className={styles.headerDivider} aria-hidden="true" />
                  <button
                    type="button"
                    ref={profileTriggerRef}
                    className={styles.profileAvatar}
                    aria-label="Open profile menu"
                    aria-controls="profilePopup"
                    aria-expanded={isProfileTooltipOpen}
                    onClick={() => {
                      setIsProfileTooltipOpen((prev) => !prev);
                      if (!isProfileTooltipOpen) {
                        GaEventHelper.gaProfileEvent({ userDetails: userDetails, screen_name: history?.location?.pathname?.replace('/', ''), event: GA_EVENTS.Profile_view, selectedBsa: selectedBsa })
                      }
                    }}
                  >
                    <img
                      src={ProfileIcon}
                      alt="Profile"
                      data-tooltip-id="profilePopup"
                    />
                  </button>
                  {isProfileTooltipOpen && (
                    <Tooltip
                      className={styles.popupModal}
                      id="profilePopup"
                      place="bottom"
                      isOpen={isProfileTooltipOpen}
                      offset="8"
                      noArrow
                      clickable
                    >
                      <div ref={profileTooltipRef} className={styles.popup}>
                        <div className={styles.popupDetails}>
                          <img src={logoutProfileIcon} className={styles.popupUserIcon} alt="" />
                          <div className={styles.popupUserInfo}>
                            <h4>{userDetails.name}</h4>
                            <p>{userDetails.email}</p>
                          </div>
                        </div>
                        {/* Show account details directly inside the desktop profile popover. */}
                        <div className={styles.popupBody}>                        
                          <div className={styles.infoBlock}>
                            <p className={styles.title}>Role</p>
                            <p className={styles.display}>{profileRole}</p>
                          </div>
                          {canViewUserAccessManagement && (
                            <button type="button" onClick={handleUserAccessManagementNavigation} className={styles.inlineLogout} aria-label="User Access Management">
                              <p>User Access Management</p>
                            </button>
                          )}
                          <button type="button" onClick={logoutHandler} className={styles.popupLogout} aria-label="Logout">
                            <p>Logout</p>
                          </button>
                        </div>
                      </div>
                    </Tooltip>
                  )}
                </>
              )}
              {menu && isHamburgerView && (
                <div className={styles.inlineProfilePanel}>
                  <div className={styles.inlineProfileHeader}>
                    <img src={logoutProfileIcon} className={styles.inlineProfileIcon} alt="" />
                    <div className={styles.inlineProfileInfo}>
                      <h4>{userDetails.name}</h4>
                      <p>{userDetails.email}</p>
                    </div>
                  </div>
                  {/* Keep profile actions visible in the hamburger drawer without extra clicks. */}
                  <div className={styles.inlineProfileBody}>                    
                    <div className={styles.inlineInfoBlock}>
                      <p className={styles.inlineTitle}>Role</p>
                      <p className={styles.inlineDisplay}>{profileRole}</p>
                    </div>
                    {canViewUserAccessManagement && (
                      <button type="button" onClick={handleUserAccessManagementNavigation} className={styles.inlineLogout} aria-label="User Access Management">
                        <p>User Access Management</p>
                      </button>
                    )}
                    <button type="button" onClick={logoutHandler} className={styles.inlineLogout} aria-label="Logout">
                      <p>Logout</p>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {!['createcohort', 'previewcohort', 'setupcohortparameter', 'landingscreen'].some(route => history?.location?.pathname === `/${route}`) && history?.location?.pathname !== '/' && (
          <LandingTabs tabs={tabItems} activeTabId={activeTabId} />
        )}
      </div>
    </>
  );
};

export default LandingHeader;




